/**
 * Created by daniel on 17/04/17.
 *
 * Acts as a host for user-defined content. Manages editor lifecycle.
 *
 * Can only be placed in RowItem components.
 *
 */

import React, {Component} from 'react';
import StyleItem from "./StyleItem";
import DropZone from "../ui/DropZone";
import * as _ from "lodash/object";

class Column extends Component {
  render() {
    return (
      <td
        id={this.props.contentId}
        className={[this.props.contentId, this.props.viewClass,].join(" ").trim()}
        ref={(node) => {
          _.toPairs(this.props.viewAttributes).map((item) => {
            return node && node.setAttribute(item[0], item[1]);
          });
        }}
        {...this.props.eventHandlers}
        style={{
          width: this.props.styleWidth,
          height: this.props.styleHeight,
          backgroundColor: this.props.styleBackgroundColour,
          color: this.props.styleTextColour,
          textAlign: this.props.styleTextAlignment,
        }}
      >
        <StyleItem selectorPrefix={this.props.contentId + " "} styleObject={this.props.viewCss}/>
        <table
          ref={(node) => {
            let attrs = {
              border: 0,
              cellpadding: 0,
              cellspacing: 0,
            };
            _.toPairs(attrs).map((item) => {
              return node && node.setAttribute(item[0], item[1]);
            });
          }}
          style={{
            width: "100%",
            height: this.props.styleHeight,
            backgroundColor: this.props.styleBackgroundColour,
            color: this.props.styleTextColour,
            textAlign: this.props.styleTextAlignment,
          }}
        >
          <tbody>
          <tr
            ref={(node) => {
              let attrs = {
                align: "center",
                valign: "top",
              };
              _.toPairs(attrs).map((item) => {
                return node && node.setAttribute(item[0], item[1]);
              });
            }}
          >
            <td
              ref={(node) => {
                let attrs = {
                  align: "center",
                  valign: "top",
                };
                _.toPairs(attrs).map((item) => {
                  return node && node.setAttribute(item[0], item[1]);
                });
              }}
              style={{
                padding: this.props.stylePadding,
              }}
            >
              <table
                ref={(node) => {
                  let attrs = {
                    border: 0,
                    cellpadding: 0,
                    cellspacing: 0,
                  };
                  _.toPairs(attrs).map((item) => {
                    return node && node.setAttribute(item[0], item[1]);
                  });
                }}>
                <tbody>
                {
                  this.props.children.length > 0 ? this.props.children : <tr><td><DropZone text={this.props.configName}/></td></tr>
                }
                </tbody>
              </table>
            </td>
          </tr>
          </tbody>
        </table>
      </td>
    );
  }
}

export default Column;


// WEBPACK FOOTER //
// ./src/App/Editor/components/primitives/Column.js